import {useState} from "react";
import "../styleSheets/aboutStyle.css"
import {Reel} from "./portraitReel";

const values =[
    {
        title: "Creativity",
        description: "Our aim is to produce action that adds creative value to a project, taking " +
            "the necessary technical components of an action sequence and crafting them into a piece" +
            " of art that hits hard. \n From fights to battle scenes, from the simple to the more " +
            "ambitious, from modern day to period drama, we will help you tell the story, not just" +
            " doing stunts for the sake of doing stunts."
    },
    {
        title: "Experience",
        description: "TLS Action is overseen and run by Tony Lucken, who started professionally in " +
            "the stunt industry back in 1992.\nHaving in excess of 30 years of experience at the " +
            "cutting edge of creating and performing stunts and action sequences worldwide, in film," +
            " television and live shows.\n" +
            "We are able to provide everything from script breakdowns and budgeting through to the " +
            "creation of dynamic, exciting action sequences.\n" +
            "Whether the stunts involve fire, high falls, vehicles, water or weapons, we have got it " +
            "covered."
    },
    {
        title: "Teamwork",
        description: "Working as a team is at the heart of everything we do and is paramount to our success.\n" +
            "Our team are dedicated to working in a confident, calm, reassuring and effective" +
            " manner to deliver the best action sequences possible. We promote a positive, friendly " +
            "culture where everyone is encouraged to contribute and ask questions. We work " +
            "together to deliver the best action possible in the safest possible way."
    },
    {
        title: "Safety",
        description: "At TLS Action Health & Safety is integral to how we work.\n" +
            "Tony Lucken has passed the Level 3 NEBOSH Certificate in Construction Health & " +
            "Safety and is an Affiliate member of IOSH. As such he is continually improving his\n" +
            "Health & Safety CPD (Continuing Professional Development).\n" +
            "He is also a Full Member of the British Stunt Register and has completed the Level 4 " +
            "Safe Management of Stunts Health & Safety Certificate."
    }
];

export function AboutSection(){
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };
    return (
        <div className={"about_section"}>
            <h1>TLSAction</h1>
            <Reel />
            <p>TLSAction, run by Tony Lucken, has been providing industry leading stunts and action for film and television since 1992.</p>
            <div className="values_wrapper">
                <div className="values_section">
                    {values.map((value, index) => {
                        const isOpen = openIndex === index;
                        return (
                            <div
                                key={value.id || index}
                                className={`values_container ${isOpen ? "open" : ""}`}
                                onClick={() => handleToggle(index)}
                            >
                                <h3 className="values_title">
                                    {value.title}
                                </h3>

                                <div className="values_body">
                                    <p>{value.description}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}


